module.exports = require("@swa-ui/core/src/DateSelector/DateSelector.module.scss");